import React from 'react';
import uflowIcon from '../../../pic/uflowIcon.png';
import './Footer.css';

const Footer = () => {
    return (
        <div className='footer-container' >
            <div className="footer-section">
                <div className="footer-content">
                    <div className="footer-logo">
                        <img src={uflowIcon} alt="UFlow Logo" />

                    </div>
                
                </div>
                <div className="footer-bottom">
                    <p>©UFLOW 2024. All rights reserved</p>
                </div>
            </div>
        </div>
    );
}

export default Footer;
